import { CLASS_getInstance14ex35co4jkrb as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  matches2uu672wulv59r as matches,
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  priority7vn90mx06311 as priority,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { tryChildSerializers3gpe7qns3v7j as tryChildSerializers } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { serializationCast3kgcg1j7intug as serializationCast } from './default.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var InlineFormRendererClass;
function InlineFormRenderer() {
  if (InlineFormRendererClass === VOID) {
    class $ {
      constructor() {
        InlineFormRenderer_instance = this;
        this.tdy_1 = CLASS_getInstance();
      }
      k20() {
        return 'Inline Wrapper';
      }
      cdu() {
        return 0.4;
      }
      s11() {
        return this.tdy_1;
      }
      ddu(module_0, selector) {
        return selector.edu_1.az().t11() && matches.call(this, module_0, selector);
      }
      idu(module_0, selector) {
        var tmp = ensureNotNull(ensureNotNull(tryChildSerializers(selector.edu_1))[0]);
        var innerSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var innerSelector = selector.copyChangingType(innerSerializer);
        var inner = module_0.ydt(innerSelector);
        return inner.p1();
      }
      ldu(module_0, selector) {
        var tmp = ensureNotNull(ensureNotNull(tryChildSerializers(selector.edu_1))[0]);
        var innerSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var innerSelector = selector.copyChangingType(innerSerializer);
        var inner = module_0.ydt(innerSelector);
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.mdu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, field, mutable) => {
          var tmp = inner.tds();
          var tmp_0 = (v) => serializationCast(selector.edu_1, v, innerSerializer);
          return tmp($this$FormRenderer, field, mutable.tak(tmp_0, (v) => serializationCast(innerSerializer, v, selector.edu_1)));
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      ndu(module_0, selector) {
        var tmp = ensureNotNull(ensureNotNull(tryChildSerializers(selector.edu_1))[0]);
        var innerSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        var innerSelector = selector.copyChangingType(innerSerializer);
        var inner = module_0.zdt(innerSelector);
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, field, readable) => {
          var tmp = inner.tds();
          return tmp($this$ViewRenderer, field, lens(readable, (v) => serializationCast(selector.edu_1, v, innerSerializer)));
        });
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    initMetadataForObject($, 'InlineFormRenderer', VOID, VOID, [Generator(), Generator_0()]);
    InlineFormRendererClass = $;
  }
  return InlineFormRendererClass;
}
var InlineFormRenderer_instance;
function InlineFormRenderer_getInstance() {
  if (InlineFormRenderer_instance === VOID)
    new (InlineFormRenderer())();
  return InlineFormRenderer_instance;
}
//region block: exports
export {
  InlineFormRenderer_getInstance as InlineFormRenderer_getInstance1ts6ggnqmxq4m,
};
//endregion

//# sourceMappingURL=InlineFormRenderer.mjs.map
